import { createFileRoute } from '@tanstack/react-router';
import { NaverBlogAnalyticsPage } from '../../../pages/tools/naver/NaverBlogAnalyticsPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/naver-blog-analytics')({
  head: () => toolHead('naver-blog-analytics'),
  component: NaverBlogAnalyticsPage,
});
